import { BehaviorSubject } from 'rxjs';

export class ExpandableRowsService<T = object> {
    private _rowsExpanded: T[] = [];
    public rowsExpandedSubject = new BehaviorSubject<T[]>([]);

    constructor() {
        this.rowsExpandedSubject.subscribe((rowsExpanded) => {
            if (rowsExpanded) {
                this._rowsExpanded = [...rowsExpanded];
            }
        });
    }

    public get rowsExpanded(): T[] {
        return this._rowsExpanded;
    }

    public expand(row: T): void {
        if (row) {
            const rowsExpanded = [...this._rowsExpanded];
            if (!this.isRowExpanded(row)) {
                rowsExpanded.push({ ...(row as any) });
                this.rowsExpandedSubject.next(rowsExpanded);
            }
        }
    }

    public collapse(row: T): void {
        const rowsExpanded = [...this._rowsExpanded];
        const existingRowIndex = this.getRowIndex(row);
        if (this.isRowExpanded(row)) {
            rowsExpanded.splice(existingRowIndex, 1);
            this.rowsExpandedSubject.next(rowsExpanded);
        }
    }

    public expandMany(rows: T[]): void {
        const finalIndex = rows.length - 1;
        const rowsExpanded = [...this._rowsExpanded];
        rows.forEach((row, index) => {
            if (row && !this.isRowExpanded(row, rowsExpanded)) {
                rowsExpanded.push({ ...(row as any) });
            }

            if (index === finalIndex) {
                this.rowsExpandedSubject.next(rowsExpanded);
            }
        });
    }

    public collapseAll(): void {
        this._rowsExpanded = [];
        this.rowsExpandedSubject.next([]);
    }

    public isRowExpanded(row: T, rowsExpanded?: T[]): boolean {
        return this.getRowIndex(row, rowsExpanded) > -1;
    }

    public getRowIndex(row: T, rowsExpanded?: T[]): number {
        const rows = rowsExpanded || this._rowsExpanded;
        return rows.findIndex((existingRow) =>
            Object.keys(existingRow).every((key) => (existingRow as any)[key] === (row as any)[key])
        );
    }
}
